/** Пустой экран: что здесь будет и кнопка первого действия. */
export function EmptyState({ icon, title, text, action }: { icon: string; title: string; text?: string; action?: { label: string; onClick: () => void } }) {
  return (
    <div className="empty-state">
      <div className="empty-icon" aria-hidden="true">
        {icon}
      </div>
      <div className="empty-title">{title}</div>
      {text && <p className="empty-text">{text}</p>}
      {action && (
        <button className="btn btn-primary" onClick={action.onClick}>
          {action.label}
        </button>
      )}
    </div>
  );
}

/** Серые плашки вместо карточки, пока данные грузятся. */
export function SkeletonCard({ lines = 3 }: { lines?: number }) {
  return (
    <section className="dash-card" aria-busy="true">
      <div className="skeleton skeleton-title" />
      {Array.from({ length: lines }, (_, i) => (
        <div key={i} className="skeleton skeleton-line" />
      ))}
    </section>
  );
}
